import React from 'react';
import {
  InputLabel,
  TextField,
  Typography,
  useMediaQuery,
} from '@mui/material';

const useStyles = () => ({
  inputLabel: {
    marginBottom: '10px',
    color: 'black',
  },
  inputContainer: {
    width: '100%',
  },
  helperText: {
    color: 'grey.600',
  },
  helperErrorText: {
    display: 'flex',
    color: 'error.main',
    width: '250px',
    marginLeft: '10px',
  },
  responsivePosition: {
    display: 'flex',
    justifyContent: 'space-between',
  },
});

function Input({
  id,
  label,
  parentStyle,
  errorTextInRed,
  helperText,
  FormHelperTextProps,
  ...rest
}) {
  const isSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const classes = useStyles();

  function classSelector() {
    if (FormHelperTextProps) {
      return FormHelperTextProps;
    }
    if (errorTextInRed) {
      return classes.helperErrorText;
    }
    return classes.helperText;
  }

  return (
    <div style={{ ...classes.inputContainer, ...(parentStyle || {}) }}>
      {isSM ? (
        <InputLabel sx={classes.inputLabel} htmlFor={id}>
          <Typography variant="old_font">{label}</Typography>
          <Typography variant="caption_old_font" sx={classSelector()}>
            {helperText}
          </Typography>
        </InputLabel>
      ) : (
        <InputLabel sx={classes.inputLabel} htmlFor={id}>
          <div style={classes.responsivePosition}>
            <Typography variant="old_font">{label}</Typography>
            <Typography variant="caption_old_font" sx={classSelector()}>
              {helperText}
            </Typography>
          </div>
        </InputLabel>
      )}

      <TextField
        {...rest}
        sx={classes.inputContainer}
        id={id}
        variant="outlined"
      />
    </div>
  );
}

export default Input;
